<template>
  <div class="meeting-detail" v-loading="loading">
    <div class="container1">
      <div class="flex">
        <div class="meeting-detail-left">
          <template v-if="data.coverImageUrl">
            <img
              :src="data.coverImageUrl">
          </template>
          <template v-else>
            <img src="https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/PC/CAC/meeting_default_image.png">
          </template>

        </div>
        <div class="meeting-detail-right">
          <div class="meeting-detail-title">{{ data.enActivityTheme }}</div>
          <div class="meeting-detail-date">
            <span style="margin-right: 4px;">Time:</span>
            <span>
              <span style="margin-right: 8px;">{{ data.activityStartDate | formatDate('y-m-d') }}</span>
              <span style="color: #009A6D;">{{ data.activityStartDate | formatDate('hours') }}</span>
            </span>
          </div>
          <div class="meeting-detail-btn">
            <el-button size="small" type="primary">Application</el-button>
          </div>
          <div class="meeting-detail-desc">{{ data.enIntroduce }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { activityQueryDetail } from '@/api'
export default {
  data() {
    return {
      loading: true,
      data: {}
    }
  },
  mounted() {
    this.getData()

    console.log('this.$router----->', this.$route.params.id)
  },
  methods: {
    // 获取数据列表
    async getData() {
      this.loading = true
      const res = await activityQueryDetail({ id: this.$route.params.id })
      if (res.data.code == 1000) {
        this.data = res.data?.data?.activity || {}
      }
      this.loading = false
    },
  }
    
  }
</script>

<style lang="stylus" scoped>
.meeting-detail {
  padding: 148px 10px 50px 10px;
  .container1{
    max-width: 1366px;
    margin: 0 auto;
    background: #fff;
    padding:16px;
    height:auto;
  }
  .meeting-detail-left{
    flex-shrink: 0;
    width: 624px;
    height:320px;
    margin-right:17px;
    img{
      width:100%;
      height: 100%
    }
  }
  .meeting-detail-right{
    flex-grow: 1;
  }
  .meeting-detail-title{
    font-weight: 600;
    font-size: 24px;
    color: rgba(0,0,0,0.85);
    line-height: 24px;
    margin-bottom:12px;
  }
  .meeting-detail-name{
    font-weight: 400;
    font-size: 16px;
    color: rgba(66,66,66,0.45);
    line-height: 16px;
    margin-bottom:16px;
  }
  .meeting-detail-date{
    font-weight: 400;
    font-size: 16px;
    color: rgba(66,66,66,0.65);
    line-height: 16px;
    margin-bottom:20px;
  }
  .meeting-detail-tips{
    font-weight: 600;
    font-size: 16px;
    color: rgba(0,0,0,0.65);
    line-height: 16px;
    margin-bottom:10px;
  }
  .meeting-detail-desc{
    font-weight: 400;
    font-size: 14px;
    color: rgba(0,0,0,0.45);
    line-height: 24px;
  }
  .meeting-detail-btn{
    margin-bottom:24px;
  }
}
</style>